import { useParams } from 'react-router';

/**
 * The rest of the url after a `/*` route: the folder path on a cloud-drive
 * page, the playlist id on the library page. Undefined at the route's root,
 * where the router reports an empty string, so that callers can test for a
 * path with a plain truthiness check.
 *
 * The router decodes the segment once. A folder name with a literal `%` or
 * `#` reaches the url as `%2525` / `%23` (see linkEncodeUri) and comes back
 * here as `%25` / `#`, which is what the drive APIs are then given.
 */
export default function useRoutePath(): string | undefined {
  return useParams()['*'] || undefined;
}
